import React, { FC } from 'react'
import { Table } from 'src/components'
import { AdminNotification } from 'src/api'
import { AdminNotificationColumns } from 'src/components/columns/user'
import { useUserMeAdminNotificationRequest } from 'src/hooks/api'
import { useAddPopupMessage } from 'src/hooks/ui'

const getColumns = () => [
  AdminNotificationColumns.NotificationName,
  AdminNotificationColumns.Active
]

interface AdminNotificationListProps {
  notifications: AdminNotification[];
  updateUser: () => void;
  showFooter?: boolean;
}

export interface EnrichedAdminNotification extends AdminNotification {
  toggle: () => void
}

export const AdminNotificationList: FC<AdminNotificationListProps> = ({
  notifications,
  updateUser,
  showFooter = true,
}) => {
  const addMessage = useAddPopupMessage()
  const request = useUserMeAdminNotificationRequest({
    options: {
      onSuccess: () => {
        updateUser()
      },
      onError: ({ message: text }) => {
        addMessage({ text, type: 'error' })
        updateUser()
      },
    },
  })
  const enrichedNotifications: EnrichedAdminNotification[] = notifications?.map<EnrichedAdminNotification>((notification) => ({
    ...notification,
    toggle: () => {
      request.mutate({
        notificationType: notification.notificationType,
        isActive: !notification.isActive
      })
      notification.isActive = !notification.isActive
    }
  })) || []
  return (
    <Table
      columns={getColumns()}
      data={enrichedNotifications}
      showFooter={showFooter}
    />
  )
}
